import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
export function MpaIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 1.92131 1.012"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs></defs>
        <g id="Layer_x0020_1">
          <metadata id="CorelCorpID_0Corel-Layer" />
          <path
            className="fil0"
            d="M1.24847 0.513667l0 -0.458792c0,-0.0278306 -0.0225632,-0.0503938 -0.0503938,-0.0503938 -0.0278306,0 -0.0503938,0.0225632 -0.0503938,0.0503938l0 0.458792 0.100788 0z"
          />
          <path
            className="fil0"
            d="M1.14768 0.84392l0 0.11262c0,0.0278306 0.0225632,0.0503938 0.0503938,0.0503938 0.0278306,0 0.0503938,-0.0225632 0.0503938,-0.0503938l0 -0.11262 -0.100788 0z"
          />
          <path
            className="fil0"
            d="M1.46362 0.264116l0 -0.209241c0,-0.0278306 -0.0225632,-0.0503938 -0.0503938,-0.0503938 -0.0278306,0 -0.0503938,0.0225632 -0.0503938,0.0503938l0 0.209241 0.100788 0z"
          />
          <path
            className="fil0"
            d="M1.36283 0.594368l0 0.362171c0,0.0278306 0.0225632,0.0503938 0.0503938,0.0503938 0.0278306,0 0.0503938,-0.0225632 0.0503938,-0.0503938l0 -0.362171 -0.100788 0z"
          />
          <path
            className="fil0"
            d="M1.57795 0.755731l0 0.200809c0,0.0278306 0.0225632,0.0503938 0.0503938,0.0503938 0.0278306,0 0.0503938,-0.0225632 0.0503938,-0.0503938l0 -0.200809 -0.100788 0z"
          />
          <path
            className="fil0"
            d="M1.67874 0.425478l0 -0.370603c0,-0.0278306 -0.0225632,-0.0503938 -0.0503938,-0.0503938 -0.0278306,0 -0.0503938,0.0225632 -0.0503938,0.0503938l0 0.370603 0.100788 0z"
          />
          <path
            className="fil0"
            d="M1.79256 0.482515l0 0.474024c0,0.0278306 0.0225632,0.0503938 0.0503938,0.0503938 0.0278306,0 0.0503938,-0.0225632 0.0503938,-0.0503938l0 -0.474024 -0.100788 0z"
          />
          <path
            className="fil0"
            d="M1.89335 0.152262l0 -0.0973875c0,-0.0278306 -0.0225632,-0.0503938 -0.0503938,-0.0503938 -0.0278306,0 -0.0503938,0.0225632 -0.0503938,0.0503938l0 0.0973875 0.100788 0z"
          />
          <path
            className="fil1"
            d="M1.49157 0.512016c0,0.0157039 -0.012854,0.0285578 -0.0285578,0.0285578l-0.0995888 0c-0.0157039,0 -0.0285578,-0.012854 -0.0285578,-0.0285578l0 -0.165529c0,-0.0157039 0.012854,-0.0285775 0.0285578,-0.0285775l0.0995888 0c0.0157039,0 0.0285578,0.0128736 0.0285578,0.0285775l0 0.165529z"
          />
          <path
            className="fil1"
            d="M1.27643 0.761568c0,0.0157039 -0.012854,0.0285578 -0.0285775,0.0285578l-0.0995691 0c-0.0157235,0 -0.0285775,-0.012854 -0.0285775,-0.0285578l0 -0.165529c0,-0.0157039 0.012854,-0.0285578 0.0285775,-0.0285578l0.0995691 0c0.0157235,0 0.0285775,0.012854 0.0285775,0.0285578l0 0.165529z"
          />
          <path
            className="fil1"
            d="M1.70671 0.673359c0,0.0157235 -0.012854,0.0285775 -0.0285578,0.0285775l-0.0995888 0c-0.0157039,0 -0.0285578,-0.012854 -0.0285578,-0.0285775l0 -0.16551c0,-0.0157039 0.012854,-0.0285775 0.0285578,-0.0285775l0.0995888 0c0.0157039,0 0.0285578,0.0128736 0.0285578,0.0285775l0 0.16551z"
          />
          <path
            className="fil1"
            d="M1.92131 0.400144c0,0.0157039 -0.012854,0.0285775 -0.0285775,0.0285775l-0.0995691 0c-0.0157039,0 -0.0285775,-0.0128736 -0.0285775,-0.0285775l0 -0.16551c0,-0.0157235 0.0128736,-0.0285775 0.0285775,-0.0285775l0.0995691 0c0.0157235,0 0.0285775,0.012854 0.0285775,0.0285775l0 0.16551z"
          />
          <path
            className="fil0"
            d="M0.464413 0.539356c-0.022406,0 -0.0428466,-0.0150749 -0.0487429,-0.0377757l-0.11258 -0.438509c-0.00699696,-0.0269462 0.0091786,-0.0544426 0.0361248,-0.0614396 0.00414707,-0.00108099 0.00829415,-0.001592 0.0123823,-0.00163131l0.000530668 0c0.0223274,9.82719e-005 0.04265,0.0151339 0.0485267,0.0377757l0.11258 0.438509c0.00699696,0.0269462 -0.0091786,0.0544426 -0.0361248,0.0614396 -0.00424535,0.00110065 -0.00849069,0.00163131 -0.0126967,0.00163131z"
          />
          <path
            className="fil0"
            d="M0.449928 1.012c-0.099176,0 -0.164605,-0.036341 -0.205231,-0.0725836 -0.0609679,-0.0544426 -0.0864989,-0.125847 -0.0962868,-0.163583 -0.00632871,-0.0244107 -0.0924542,-0.259143 -0.145246,-0.401382 -0.00968961,-0.026101 0.00361641,-0.0551109 0.0297174,-0.0647808 0.0260814,-0.00970926 0.0550912,0.00361641 0.0647808,0.0296978 0.0230939,0.0622454 0.138819,0.374554 0.148312,0.41115 0.0204995,0.078991 0.0875013,0.20303 0.30596,0.146386 0.154641,-0.0400949 0.22294,-0.136008 0.208769,-0.293204 -0.00507083,-0.0561526 0.0437507,-0.24226 0.0588452,-0.29798 0.00727212,-0.0268479 0.0349651,-0.0427286 0.061813,-0.0354565 0.0268675,0.00727212 0.0427483,0.0349455 0.0354762,0.061813 -0.0285971,0.105564 -0.0580197,0.235971 -0.0557398,0.262563 0.0185341,0.205585 -0.0822929,0.347568 -0.283868,0.399829 -0.0475636,0.012343 -0.0898402,0.0175317 -0.127301,0.0175317z"
          />
          <path
            className="fil0"
            d="M0.298825 0.592324c-0.0225632,0.000353779 -0.0433379,-0.0145836 -0.0494308,-0.037363l-0.102812 -0.387604c-0.00721316,-0.0268872 0.0087462,-0.0545213 0.0356334,-0.0617148 0.0268872,-0.00721316 0.0545213,0.00876585 0.0617148,0.035653l0.102812 0.387604c0.00721316,0.0268675 -0.0087462,0.0545016 -0.0356334,0.0617148 -0.00410777,0.00108099 -0.00823519,0.00165097 -0.012284,0.00170993z"
          />
          <path
            className="fil0"
            d="M0.635367 0.508302c-0.0226418,0 -0.04322,-0.0153697 -0.0488804,-0.0383457l-0.100611 -0.393048c-0.00666284,-0.0270248 0.00984685,-0.0543247 0.0368716,-0.0609875 0.0270248,-0.00666284 0.0543444,0.00984685 0.0609875,0.0368716l0.100611 0.393029c0.00666284,0.0270248 -0.00984685,0.0543444 -0.0368716,0.0610072 -0.0040488,0.00100237 -0.00811726,0.00147408 -0.0121071,0.00147408z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
